import React, { useState } from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import LaboratoryRequestTemplateCreate from './LaboratoryRequestTemplateCreate';
import { Size } from '../../../../../Enums/Size.enum';
import { LaboratoryTemplateType } from '../../../Enums/LaboratoryTemplateType.enum';

interface Props extends BaseModalProps {
	workplaceId: string;
	doctorId: string;
	onCreate: (templateType: LaboratoryTemplateType) => void;
}

const LaboratoryRequestTemplateCreateModal: React.FC<Props> = props => {
	const [modalSize, setModalSize] = useState<Size>(Size.MD);

	return (
		<BaseModal
			{...props}
			title='component.laboratoryRequestTemplateCreate.modalTitle'
			size={modalSize}>
			<LaboratoryRequestTemplateCreate
				workplaceId={props.workplaceId}
				doctorId={props.doctorId}
				changeModalSize={size => setModalSize(size)}
				onCreate={props.onCreate}
			/>
		</BaseModal>
	);
};

export default LaboratoryRequestTemplateCreateModal;
